// extracted by mini-css-extract-plugin
export default {"card-primary":"CardPrimary_card-primary__5GVtF","card-priimary":"CardPrimary_card-priimary__kAzAU"};